<div
  class="instrument-details_chart__IVX30"
  #instumentDetails
  (window:resize)="onResize(instumentDetails)"
>
  <div
    #ivx30Container
    class="app-tv-chart-container"
    id="tv_chart_container"
    style="font-size: 10px !important;"
  ></div>
</div>
